module.exports = "/images/pin-multidis.png?3585b12fe24d6c7f7b81d0f5c366a470";